<template>
<button class="odr-main-button"
        :class="{
            'odr-main-button_clean': clean ==='true',
            'odr-main-button_rounded': rounded ==='true',
            [`odr-main-button_background-color-${color}`]: color
        }"
        :style="style"
        @click="$emit('click')">
    <slot></slot>
</button>
</template>

<script>
import '../styles/main-button.scss'
import { coloringMixin } from '../mixins/coloring'

export default {
    mixins: [coloringMixin],
    props: {
        clean: {
            type: String,
            _descr: 'Clean style',
        },
        width: {
            type: String,
            _descr: 'Button width',
        },
        rounded: {
            type: String,
            _descr: 'Button rounded style',
        },
        exactColor: {
            type: String,
            _descr: 'Button exact background color',
        },
    },
    computed: {
        style () {
            return `${this.width ? `width: ${this.width} !important;` : ''} ${this.exactColor ? `background-color: ${this.exactColor} !important;` : ''}`
        },
    },
}
</script>
